import { render, staticRenderFns } from "./MigrationStartCard.vue?vue&type=template&id=1bee8f6e&"
import script from "./MigrationStartCard.vue?vue&type=script&lang=js&"
export * from "./MigrationStartCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1bee8f6e')) {
      api.createRecord('1bee8f6e', component.options)
    } else {
      api.reload('1bee8f6e', component.options)
    }
    module.hot.accept("./MigrationStartCard.vue?vue&type=template&id=1bee8f6e&", function () {
      api.rerender('1bee8f6e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Migrations/MigrationStartCard.vue"
export default component.exports